import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  // withCredentials=false: Bearer token (Authorization header) kullandığımız için cookie gerekmez.
  // withCredentials=true + backend allow_origins=["*"] tarayıcı tarafından reddedilir
  // ve "Network Error" fırlatır. Bu yüzden false olmalı.
  withCredentials: false,
});

// Bearer fallback (cookies may be blocked by some proxies)
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    try { localStorage.setItem("mb_token", token); } catch (_) {}
  } else {
    delete api.defaults.headers.common["Authorization"];
    try { localStorage.removeItem("mb_token"); } catch (_) {}
  }
};

// Rehydrate on load
try {
  const saved = localStorage.getItem("mb_token");
  if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;
} catch (_) {}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export const STATUS_LABELS = {
  SIPARIS_ALINDI: "Bekliyor",
  URETIM_BEKLIYOR: "Üretime Hazır",
  URETIMDE: "Üretimde",
  HAZIR: "Hazır",
  SEVKIYATA_HAZIR: "Hazır",
  SEVK_EDILDI: "Sevk Edildi",
};

export const STATUS_CHIP = {
  SIPARIS_ALINDI: "chip chip-siparis",
  URETIM_BEKLIYOR: "chip chip-bekliyor",
  URETIMDE: "chip chip-uretimde",
  HAZIR: "chip chip-hazir",
  SEVKIYATA_HAZIR: "chip chip-sevkhaz",
  SEVK_EDILDI: "chip chip-sevk",
};

export const ROLE_LABELS = {
  admin: "Yönetici",
  production_manager: "Üretim Müdürü",
  production_operator: "Üretim Operatörü",
  shipping_operator: "Sevkiyat Operatörü",
  view_only: "Görüntüleyici",
  yatak_paketleme: "Yatak Paketleme",
  terzihane_yatak: "Terzihane Yatak",
  terzihane1: "Terzihane 1",
  baza_uretim: "Baza Üretim",
  kontrol_operator: "Kontrol Operatörü",
  baslik_doseme: "Başlık Döşeme",
};

// Config-driven UI hint for limited roles (frontend fallback if backend cfg not present)
export const LIMITED_ROLES = [
  "yatak_paketleme",
  "terzihane_yatak",
  "terzihane1",
  "baza_uretim",
  "kontrol_operator",
  "baslik_doseme",
];

export const isLimitedRole = (role) => LIMITED_ROLES.includes(role);

// (Category, Model) → varsayılan pieces_per_product (parça sayısı)
// Baza için tüm standart ölçüler her zaman 2. Başlık için model bazlı.
// Kullanıcı sonradan sipariş detayında elle değiştirebilir.
export function resolveDefaultPieces(category, model) {
  const cat = (category || "").trim();
  const mdl = (model || "").trim().toLowerCase();
  if (cat === "Baza") return 2;
  if (cat === "Başlık") {
    if (["capella", "deluxe", "juliet", "florida"].includes(mdl)) return 2;
    if (mdl === "alfa") return 4;
    if (mdl === "balance") return 3;
    return 1;
  }
  return 1;
}

export function formatDateTR(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
}

export function formatDateTimeTR(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${dd}.${mm}.${yyyy} ${hh}:${mi}`;
}
